<template>
  <button
    class="k-button"
    :disabled="disabled"
    :class="classes"
  >
    <div class="k-button-container">
      <k-icon
        v-if="!noIcon && !loading"
        :icon="iconAdjusted"
        class="icon"
        :style="iconStyles"
      />
      <div
        class="loading"
        v-if="loading"
      >
        <loading
          size="sm"
          color="white"
        />
      </div>
      <slot />
    </div>
  </button>
</template>

<script>
import KIcon from './KIcon.vue'
import Loading from './icons/Loading.vue'

export default {
  name: 'KButton',
  components: {
    KIcon,
    Loading
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'md'
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'arrow-right'
    },
    iconSize: {
      type: [String, Number],
      default: null
    },
    noIcon: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      let defaultClasses = ''
      if (this.disabled) defaultClasses += ' -disabled'
      if (this.type !== 'default') defaultClasses += ` -type-${this.type}`
      if (this.outlined) defaultClasses += ' -outlined'
      if (this.color !== 'primary') defaultClasses += ` -${this.color}`
      if (this.size !== 'md') defaultClasses += ` -${this.size}`

      return defaultClasses
    },
    iconAdjusted () {
      if (this.icon !== 'arrow-right') return this.icon
      if (this.type === 'send') return 'arrow-right'

      return 'arrow-right'
    },
    iconStyles () {
      if (this.iconSize) return `font-size: ${this.iconSize}px`
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";;

.k-button {
  background: $neutral-1;
  color: $neutral-2;
  border: none;
  width: 254px;
  height: 56px;
  padding: 0 22px;
  border-radius: 8px;
  cursor: pointer;
  transition: all ease 0.2s;
  text-transform: uppercase;
  @include heading-5;
  position: relative;

  &.-outlined {
    border-radius: 8px;
    border: 2px solid $neutral-1;
    background: $neutral-2;
    color: $neutral-1;

    &:hover {
      color: #FDFDFD;
      border-color: $outlined-hover-color;
      background: $outlined-hover-color;
    }
    &:focus {
      color: #FDFDFD;
      border-color: outlined-focus-color;
      background: $outlined-focus-color;
      cursor: not-allowed;
    }
    &:disabled {
      color: #FDFDFD;
      border: none;

      &:hover {
        background: $disabled-color;
      }
    }
  }

  .k-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 15px;
  }

  @include media-query(mobile) {
    width: 100%;
  }
  .loading {
    width: 20px;
    height: 20px;
  }

  .icon,
  .loading {
    position: absolute;
    left: 15px;
    right: auto;
    bottom: 20px;
  }

  &:hover {
    background: lighten($neutral-1, 20%);
  }
  &:disabled {
    background: $disabled-color;
    cursor: not-allowed;
  }

  &.-primary-6 {
    background: $primary-6;
    &:hover {
      background: lighten($primary-6, 20%);
    }
  }

  &.-type-send {
    .icon {
      font-size: 24px;
      right: 15px;
      left: auto;
      bottom: 16px;
    }
    .loading {
      right: 15px;
      left: auto;
      bottom: 22px;
    }
    .loading {
      bottom: 19px;
    }
    &.-sm {
      .icon {
      font-size: 14px;
      right: 15px;
      left: auto;
      bottom: 16px;
    }
    }
  }

  &.-type-small {
    height: 40px;
    .icon,
    .loading {
      bottom: 14px;
    }
    .loading {
      bottom: 10px;
    }
  }
  &.-sm {
    height: 40px;
    .icon,
    .loading {
      bottom: 14px;
    }
    .loading {
      bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KButton.vue